import type { ReactNode } from 'react';
import { I } from './Icons';

export interface ModalProps {
  title: string;
  sub?: string;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
  width?: number | string;
}

export function Modal({ title, sub, onClose, children, footer, width }: ModalProps) {
  return (
    <div className="modal-scrim" onClick={onClose}>
      <div
        className="modal"
        style={width ? { width } : undefined}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-head">
          <div>
            <h2>{title}</h2>
            {sub && <div className="sub">{sub}</div>}
          </div>
          <button
            type="button"
            className="topbar icon-btn"
            onClick={onClose}
            style={{ width: 32, height: 32, borderRadius: 8, display: 'grid', placeItems: 'center' }}
            aria-label="Close"
          >
            <I.x size={18} />
          </button>
        </div>
        <div className="modal-body">{children}</div>
        {footer && <div className="modal-foot">{footer}</div>}
      </div>
    </div>
  );
}
